import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, '/programacoesitens', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `/motoristas/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, '/motoristas', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/logscarregamentos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `/motoristas/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, '/motoristas', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/logscarregamentos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const { idpreset } = yield select(
      (state) => state.logsdescarregamentositem
    );

    const { nomepresetreceita } = yield select(
      (state) => state.logsdescarregamentositem
    );

    const requestParams = {
      wherefield: [],
      valuewherefield: [],
      typewherefield: [],
    };

    // requestParams.wherefield.push('tipo_programacao');
    // requestParams.valuewherefield.push('2');
    // requestParams.typewherefield.push('EQUALS');

    if (params.wherefield) {
      for (let i = 0; i < params.wherefield.length; i += 1) {
        if (params.wherefield[i] === 'datahorainiciodescarganf') {
          requestParams.wherefield.push('datahoradescarganf');
          requestParams.valuewherefield.push(params.valuewherefield[i]);
          requestParams.typewherefield.push(params.typewherefield[i]);
        } else if (params.wherefield[i] === 'datahorafimdescarganf') {
          requestParams.wherefield.push('datahoradescarganf');
          requestParams.valuewherefield.push(params.valuewherefield[i]);
          requestParams.typewherefield.push(params.typewherefield[i]);
        } else {
          requestParams.wherefield.push(params.wherefield[i]);
          requestParams.valuewherefield.push(params.valuewherefield[i]);
          requestParams.typewherefield.push(params.typewherefield[i]);
        }
      }
    }

    // const response = yield call(api.get, '/programacoesitens', {
    const response = yield call(api.get, '/descargasnfs', {
      params: {
        ...params,
        wherefield: requestParams.wherefield,
        typewherefield: requestParams.typewherefield,
        valuewherefield: requestParams.valuewherefield,
        idpreset,
        nomepresetreceita,
      },
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@logsdescarregamentositem/DELETE_DATA', deleteData),
  takeLatest('@logsdescarregamentositem/SUCCESS_REMOVE', requestData),
  takeLatest('@logsdescarregamentositem/STORE_DATA', store),
  takeLatest('@logsdescarregamentositem/FIND_DATA', find),
  takeLatest('@logsdescarregamentositem/UPDATE_DATA', update),
  takeLatest('@logsdescarregamentositem/RECORD_FILTERING', applyedFilters),
]);
